import React, { useState } from "react";
import styles from "./SingleTopics.module.scss";
import {
  getDefaultImage,
  timestampToTime,
  sendEventTracking,
} from "../../utils/GeneralUtils";
import Content from "./Content";
import { OutputBlockData } from "@editorjs/editorjs";
import TopicsItemWriter from "./TopicsItemWriter";
import ShareSNS from "../../common/sns/ShareSNS";
import BackToListButton from "../backtolistbutton/BackToListButton";
import { useAppSelector } from "../../redux/hooks";
import { AuthStatus, getAuthStatus } from "../../redux/reducers/auth";
import { SonicTermData } from "../../common/classes/SonicTerm";
import MainGame from "../person-single/MainGame";
import ContentReportModalContainer from "../../common/report/ContentReportModalContainer";
import { PageTypes } from "../../utils/PageTypes";
import ContentReportButton from "../../common/report/ContentReportButton";
import SonicLink from "../../common/routing/SonicLink";

type Props = {
  imgSrc?: string;
  type?: string;
  date?: number;
  title?: string;
  tags?: Array<string>;
  game?: Array<SonicTermData>;
  content?: Array<OutputBlockData>;
  authorName?: string;
  isPreview?: boolean;
  relatedContents?: React.ReactNode;
};
const SingleTopics: React.FC<Props> = ({
  imgSrc,
  type,
  date,
  title,
  tags,
  game,
  content,
  authorName,
  isPreview = false,
  relatedContents,
}) => {
  const auth_status = useAppSelector(getAuthStatus);

  const [isReportModalShown, setIsReportModalShown] = useState<boolean>(false);

  return (
    <>
      <div className={styles["singleTopics__wrapper"]}>
        <div
          className={
            isPreview
              ? `${styles["singleTopics"]} ${styles["preview"]}`
              : styles["singleTopics"]
          }
        >
          <div className={styles["singleTopics__imgBox"]}>
            <img src={imgSrc ? imgSrc : getDefaultImage()} />
          </div>
          <div className={styles["singleTopics__item"]}>
            {type ? (
              <div className={styles["typeBox"]}>
                <span className={styles["typeBox__type"]}>{type}</span>
              </div>
            ) : null}
            <div className={styles["release-date-wrapper"]}>
              {date ? (
                <span className={styles["release-date"]}>{`${timestampToTime(
                  date,
                  false,
                  false,
                  "."
                )} UP`}</span>
              ) : null}
              <ContentReportButton
                handler={
                  isPreview ? () => {} : () => setIsReportModalShown(true)
                }
              />
            </div>
            {title ? <h2 className={styles["title"]}>{title}</h2> : null}

            {tags ? (
              <div className={styles["tagBox"]}>
                {tags.map((tag, i) => {
                  return isPreview ? (
                    <span key={i} className={styles["tagBox__tag"]}>
                      {tag}
                    </span>
                  ) : (
                    <SonicLink key={i} to={`/topics/?s=${tag}`} disabled={true}>
                      <span key={i} className={styles["tagBox__tag"]}>
                        {tag}
                      </span>
                    </SonicLink>
                  );
                })}
              </div>
            ) : null}
          </div>
          {content ? (
            <div
              className={`${styles["singleTopics__item"]} ${styles["border-top"]}`}
            >
              <Content content={content} />
            </div>
          ) : null}
          {game && game.length > 0 ? (
            <div className={styles["singleTopics__game-section"]}>
              <div className={styles["singleTopics__game-section__title"]}>
                このトピックスに関連したゲーム
              </div>
              <div className={styles["games"]}>
                <MainGame games={game} isMini={true} />
              </div>
            </div>
          ) : null}
          <div className={styles["singleTopics__item"]}>
            <ShareSNS isPreview={isPreview ? true : false} />
          </div>
          {authorName ? (
            <div className={styles["singleTopics__item"]}>
              <TopicsItemWriter name={authorName} />
            </div>
          ) : null}
          {isPreview || auth_status === AuthStatus.Authenticated ? null : (
            <div className={styles["singleTopics__item"]}>
              <div className={styles["singleTopics__item__to-regist"]}>
                <SonicLink
                  to="/register"
                  onClick={() =>
                    sendEventTracking("click", "topicsDetail", "register")
                  }
                >
                  <div>あなたもSELeCTで記事を書いてライターデビュー！</div>
                  <span>新規会員登録はこちら</span>
                </SonicLink>
              </div>
            </div>
          )}
          {isPreview ? null : (
            <BackToListButton name="トピックス" to="/topics" max_width={960} />
          )}
        </div>
        <div className={styles["singleTopics__item__to-contact"]}>
          <div className={styles["singleTopics__item"]}>
            <p className={styles["balloons"]}>
              イベントご紹介・宣伝企画ご提案など
            </p>
            <SonicLink
              to="/contact"
              onClick={() =>
                sendEventTracking(
                  "click",
                  "topicsDetail",
                  "トピックス詳細-無料ご相談はこちら"
                )
              }
            >
              <span>無料ご相談はこちら</span>
            </SonicLink>
          </div>
        </div>
        {relatedContents ? relatedContents : null}
      </div>

      <ContentReportModalContainer
        isModalShown={isReportModalShown}
        closeHandler={() => setIsReportModalShown(false)}
        pageType={PageTypes.Topics}
        contentName={title}
      />
    </>
  );
};

export default SingleTopics;
